import React from "react"
import { Link } from "gatsby"

import { rhythm, scale } from "../utils/typography"

import SEO from "../components/seo"

const Layout = ({ title, children }) => {
  const rootPath = `${__PATH_PREFIX__}/`
  let header = (
    <h1
      style={{
        ...scale(1.5),
        marginBottom: rhythm(1.5),
        marginTop: 0,
      }}
    >
      <Link
        style={{
          boxShadow: `none`,
          color: `inherit`,
        }}
        to={`/`}
      >
        {"Michael Harris"}
      </Link>
    </h1>
  )
  return (
    <div
      style={{
        marginLeft: `auto`,
        marginRight: `auto`,
        maxWidth: rhythm(30),
        padding: `${rhythm(1.5)} ${rhythm(3 / 4)}`,
      }}
    >
      <SEO title={title}/>
      <header>{header}</header>
      <main>{children}</main>
    </div>
  )
}

export default Layout